import './styles.scoped.css'
import {Typography, Button, Modal, IconButton} from '@mui/material'
import {Edit, Close} from '@mui/icons-material'
import {useMobile} from '../../../../hooks'

export default ({open, setOpen, data, setOpenTeamForm}) => {
    const {mobile} = useMobile()

    const handleUpdateMember = () => {
        setOpen(false)
        setOpenTeamForm(true)
    }

    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <div className="container">
                <div className="content">
                    {mobile && (
                        <>
                            <div className="header">
                                <Typography variant="h6" color="text.primary">
                                    View Team Member
                                </Typography>
                                <IconButton onClick={() => setOpen(false)}>
                                    <Close />
                                </IconButton>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                        </>
                    )}
                    <div className="header-content">
                        <div>
                            <Typography variant="h6" color="text.primary" className="name">
                                {data?.first_name} {data?.last_name}
                            </Typography>
                            <br />
                            <Typography variant="body1" color="primary.dark">
                                {data?.roles?.join(', ')}
                            </Typography>
                            <br />
                        </div>
                        <Button startIcon={<Edit />} onClick={handleUpdateMember} variant="outlined">
                            Update Member
                        </Button>
                    </div>
                    <br />
                    <div className="form">
                        <Typography variant="h8" color="text.primary">
                            Email:
                        </Typography>
                        <Typography variant="body2" color="text.primary">
                            {data?.email}
                        </Typography>
                    </div>
                    <br />
                    <div className="form">
                        <Typography variant="h8" color="text.primary">
                            Phone Number:
                        </Typography>
                        <Typography variant="body2" color="text.primary">
                            {data?.phone}
                        </Typography>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
